/* eslint-disable */
export default {
  doNotCall: '通話拒否',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
